import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { storage } from '../lib/firebase'

export const MAX_IMAGE_BYTES = 10 * 1024 * 1024

export interface UploadedImage {
  path: string
  url: string
  name: string
}

export function validateImage(file: File): string | null {
  if (!file.type.startsWith('image/')) return `${file.name} er ikke et billede.`
  if (file.size > MAX_IMAGE_BYTES) return `${file.name} er større end 10 MB.`
  return null
}

function uniqueName(name: string): string {
  const safe = name.replace(/[^a-zA-Z0-9._-]/g, '_')
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}-${safe}`
}

/** Uploader billeder til fx enquiries/{id}/ eller cases/{id}/ og returnerer sti + URL. */
export async function uploadImages(files: File[], folder: string): Promise<UploadedImage[]> {
  const uploads = files.map(async (file) => {
    const path = `${folder}/${uniqueName(file.name)}`
    const storageRef = ref(storage, path)
    await uploadBytes(storageRef, file, { contentType: file.type })
    const url = await getDownloadURL(storageRef)
    return { path, url, name: file.name }
  })
  return Promise.all(uploads)
}

export async function deleteImage(path: string): Promise<void> {
  if (!path) return
  await deleteObject(ref(storage, path))
}
